import { attachmentSearchText } from './referralAttachments';
import { referralTypeLabel } from './referralTypeLabel';

const f = (r, k) => (r?.data || r?.Data || {})[k];

/** Searchable text for referral / vitalrounds formatted rows. */
export function referralRecordSearchBlob(record) {
  return [
    f(record, 'patient_first_name'),
    f(record, 'patient_last_name'),
    f(record, 'referral_for'),
    f(record, 'sending_user_name'),
    f(record, 'sending_facility'),
    f(record, 'sending_speciality'),
    f(record, 'creating_user_name'),
    f(record, 'creating_facility'),
    f(record, 'creating_speciality'),
    f(record, 'receiving_user_name'),
    f(record, 'receiving_facility'),
    f(record, 'receiving_speciality'),
    f(record, 'referral_number'),
    f(record, 'referral_status'),
    referralTypeLabel(record),
    attachmentSearchText(record),
  ].filter(Boolean).join(' ').toLowerCase();
}

function appendValue(parts, v) {
  if (v === null || v === undefined || v === '') return;
  if (typeof v === 'object') {
    try {
      parts.push(JSON.stringify(v));
    } catch {
      parts.push(String(v));
    }
    return;
  }
  parts.push(String(v));
}

/** Flatten a cache record into one searchable string (raw / non-referral types). */
export function genericRecordSearchBlob(record) {
  const parts = [];
  Object.entries(record || {}).forEach(([k, v]) => {
    if (k === 'data' || k === 'metadata') return;
    appendValue(parts, v);
  });
  if (record?.data && typeof record.data === 'object') {
    Object.values(record.data).forEach(v => appendValue(parts, v));
  }
  if (record?.metadata && typeof record.metadata === 'object') {
    Object.values(record.metadata).forEach(v => appendValue(parts, v));
  }
  return parts.join(' ').toLowerCase();
}

export function recordMatchesTableSearch(record, dataType, query) {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const blob = (dataType === 'referrals' || dataType === 'vitalrounds')
    ? referralRecordSearchBlob(record)
    : genericRecordSearchBlob(record);
  return blob.includes(q);
}

export function filterRecordsForTableSearch(records, dataType, query) {
  const q = query.trim();
  if (!q) return records || [];
  return (records || []).filter(r => recordMatchesTableSearch(r, dataType, q));
}
